import _ from 'lodash'

const isAdvertisementLoading = (state) => _.get(state, 'isLoading')
const banner = (state) => _.get(state, 'banner')

export default {
    isAdvertisementLoading,
    banner
}
